import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Cookie, X } from 'lucide-react';

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('cookies_accepted');
    if (!accepted) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookies_accepted', 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-fade-in" data-testid="cookie-banner">
      <div className="max-w-2xl mx-auto bg-background border shadow-lg rounded-lg p-4 flex flex-col sm:flex-row items-start sm:items-center gap-3">
        <Cookie className="h-5 w-5 text-muted-foreground flex-shrink-0 mt-0.5 sm:mt-0" />
        <p className="text-sm text-muted-foreground flex-1">
          Diese Website verwendet nur technisch notwendige Cookies für die Anmeldung. Keine Tracking- oder Marketing-Cookies.{' '}
          <Link to="/datenschutz" className="text-primary hover:underline">Mehr erfahren</Link>
        </p>
        <div className="flex gap-2 flex-shrink-0">
          <Button size="sm" onClick={handleAccept} data-testid="cookie-accept-btn">Verstanden</Button>
          <Button variant="ghost" size="sm" className="h-8 w-8 p-0" onClick={handleAccept} aria-label="Schließen">
            <X className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
